export default () => ({
  timezone: 'Europe/Amsterdam'
})
